var _g, _g2, _rect, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_9848_19165)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 71,
    fill: "#50C238"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_f_9848_19165)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 81,
    r: 55,
    fill: "#50C238"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#50C238"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 101C92 101 101 92 101 81C101 70 92 61 81 61C70 61 61 70 61 81C61 92 70 101 81 101Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 81L78.16 86.66L89.5 75.34",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9848_19165",
    x: 0,
    y: 0,
    width: 162,
    height: 162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_9848_19165"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_9848_19165",
    x: 16,
    y: 16,
    width: 130,
    height: 130,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_9848_19165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSuccess);
export default __webpack_public_path__ + "static/media/edit-success.ddd2de180c89fd11f290b5e5cb61dbfc.svg";
export { ForwardRef as ReactComponent };